import photo from "../assets/IMG_2101.jpeg";
import { ABOUT_CONTENT } from "../constants/about.constant";

export function About() {
  return (
    <section id="about" className="pb-20 px-6 md:pb-35 md:px-13">
      <div className="max-w-6xl mx-auto border-t border-border pt-20 md:pt-35">
        <p className="section-label reveal">About the artist</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 items-start">
          <div>
            <h2 className="text-[clamp(36px,5vw,72px)] font-bold tracking-[-0.02em] leading-none text-primary mb-10 reveal">
              {ABOUT_CONTENT.heading[0]}
              <br />
              {ABOUT_CONTENT.heading[1]}
            </h2>
            <div className="w-full aspect-3/4 overflow-hidden reveal">
              <img
                src={photo}
                alt="MOODE.ART artist"
                className="w-full h-full object-cover"
                style={{ filter: "brightness(0.85) contrast(1.05)" }}
              />
            </div>
          </div>
          <div className="pt-2">
            {ABOUT_CONTENT.body.map((paragraph) => (
              <p key={paragraph} className="text-[15px] leading-[1.9] text-primary/65 mb-5 reveal">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
